export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/HT-9ebd7f096e9678020f47a61c558798c6.png";